export const HARDWARE_ICON_SOURCES: Record<string, string> = {
  torx: '/static/icons/torx.svg',
  phillips: '/static/icons/phillips.svg',
  hex: '/static/icons/hex.svg',
  pozidriv: '/static/icons/pozidriv.svg',
  checkmark: '/static/icons/checkmark.svg',
  x: '/static/icons/x.svg',
  fire_hazard: '/static/icons/fireHazard.svg',
  warning: '/static/icons/warning.svg',
  iso_warning: '/static/icons/ISO-warning.svg',
  iso_explosive: '/static/icons/ISO-explosive.svg',
  iso_ionizing: '/static/icons/ISO-radioactive-ionizing-radiation.svg',
  iso_non_ionizing: '/static/icons/ISO-nonionizing-radiation.svg',
  iso_obstacle: '/static/icons/ISO-floor-level-obstacle.svg',
  iso_slippery_surface: '/static/icons/ISO-slippery-surface.svg',
  iso_electricity: '/static/icons/ISO-electricity.svg',
  iso_forklift: '/static/icons/ISO-forklift.svg',
  iso_overhead_load: '/static/icons/ISO-overhead-load.svg',
  iso_flammable: '/static/icons/ISO-flammable.svg',
  iso_sharp_object: '/static/icons/ISO-sharp-object.svg',
  iso_loud_sounds: '/static/icons/ISO-loud-sounds.svg',
}
